export const cleanStringFromTerms = (originalString, termsToRemove: string[]): string => {
	const space = ' ';
	const cleanedStringTerms = originalString.split(space);
	const filteredTerms = cleanedStringTerms.filter((s) => !termsToRemove.includes(s));
	return filteredTerms.join(space).trim();
};
